import toggleClass from "./toggleClass"

const clickActionHandler = (e) => {
    if (!e.target.classList.contains('js--action')) return

    const action = e.target.dataset.do

    switch (action) {
        case 'toggle-class':
            return toggleClass(e)
        default:
            console.log('No action handler for ' + action)
    }
}

const useClickActionHandler = () => {
    document.addEventListener('click', clickActionHandler)
}

export default useClickActionHandler
